import { render, staticRenderFns } from "./UserDropdown.vue?vue&type=template&id=52b61e3c&"
import script from "./UserDropdown.vue?vue&type=script&lang=js&"
export * from "./UserDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b61e3c')) {
      api.createRecord('52b61e3c', component.options)
    } else {
      api.reload('52b61e3c', component.options)
    }
    module.hot.accept("./UserDropdown.vue?vue&type=template&id=52b61e3c&", function () {
      api.rerender('52b61e3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/app-navbar/components/UserDropdown.vue"
export default component.exports